import { Redirect, navigate } from '@reach/router';
import React from 'react';

import MainLayout from '../components/MainLayout';
import DetailsView from '../components/DetailsView';
import DirectionsView from '../components/DirectionsView';
import RateView from '../components/RateView';
import ShareView from '../components/ShareView';

import { encode, navigations } from '../config/constants';

import { useStateValue } from '../state';

export default ({ method, detail }) => {
  const [{
    email,
    rate,
    step,
    subscribed,
    view
  }, setState] = React.useState({
    email: '',
    rate: 0,
    subscribed: false,
    step: 0,
    view: 'defaults',
  });
  const [{
    trigger: {
      show: triggerShow,
      type: triggerType,
    },
  }, dispatch] = useStateValue();
  const methodsArray = navigations.find(navigation => navigation.key === method).methods;
  const navigationsArray = methodsArray.map(method => method.key);
  const {
    details,
    quantities,
    steps,
  } = methodsArray.find(method => method.key === detail)
  const onChange = (evt, typeValue) => {
    const opts = {
      cups() {
        dispatch({
          type: 'CUP_SET',
          payload: {
            count: Number.parseInt(evt.target.value, 10),
          },
        });
      },
      newsletter() {
        const {
          value,
        } = evt.target;

        setState((prevState) => ({ ...prevState, email: value }));
      }
    };

    return opts[typeValue]();
  };
  const onClick = (typeValue, idxValue) => {
    const opts = {
      async rate() {
        try {
          if (rate) {
            await fetch('/', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: encode({
                'form-name': 'rating',
                type: detail,
                rate,
              }),
            });

            dispatch({
              type: 'MODAL_SET',
              payload: {
                show: true,
                target: 'share',
                type: 'loader',
              },
            });
          }
        } catch (error) {
          console.log(error);
        }
      },
      async subscribe() {
        try {
          if (email.match(/[^@]+@[^.]+\..+/g)) {
            await fetch('/', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: encode({
                'form-name': 'newsletter',
                email,
              }),
            });

            setState((prevState) => ({
              ...prevState,
              email: '',
              subscribed: true,
            }));
          }
        } catch (error) {
          console.log(error);
        }
      },
      back() {
        navigate(`/${method}`);
      },
      cup() {
        dispatch({
          type: 'CUP_SET',
          payload: {
            count: idxValue,
          },
        });
      },
      done() {
        dispatch({
          type: 'MODAL_SET',
          payload: {
            show: true,
            target: 'rate',
            type: 'loader',
          },
        });
      },
      grind() {
        dispatch({
          type: 'MODAL_SET',
          payload: {
            show: true,
            target: idxValue.replace(/\s+/g, '-').toLowerCase(),
            type: 'grind',
          },
        });
      },
      jump() {
        setState((prevState) => ({ ...prevState, step: idxValue}));
      },
      next() {
        setState((prevState) => ({ ...prevState, step: step + 1 }));
      },
      pause() {
        dispatch({
          type: 'TIMER_SET',
          payload: {
            action: typeValue,
            play: false,
          },
        });
      },
      play() {
        dispatch({
          type: 'TIMER_SET',
          payload: {
            action: typeValue,
            play: true,
          },
        });
      },
      prev() {
        setState((prevState) => ({ ...prevState, step: step - 1 }));
      },
      repeat() {
        dispatch({
          type: 'TIMER_SET',
          payload: {
            action: typeValue,
            play: false,
          },
        });
      },
      star() {
        setState((prevState) => ({ ...prevState, rate: rate === idxValue ? 0 : idxValue }));
      },
      start() {
        dispatch({
          type: 'MODAL_SET',
          payload: {
            show: true,
            target: 'direction',
            type: 'loader',
          },
        });
      },
    };

    return opts[typeValue]();
  };
  const viewOpts = {
    defaults: <DetailsView
      details={details}
      quantities={quantities}
      steps={steps}
      onChange={onChange}
      onClick={onClick}
    />,
    direction: <DirectionsView
      quantities={quantities}
      step={step}
      steps={steps}
      onClick={onClick}
    />,
    rate: <RateView rate={rate} onClick={onClick} />,
    share: <ShareView
      email={email}
      subscribed={subscribed}
      onChange={onChange}
      onClick={onClick}
    />,
  };

  if (!navigationsArray.includes(detail)) {
    return <Redirect to={`/${method}`} noThrow />;
  }

  React.useEffect(() => {
    if (triggerShow) {
      setState((prevState) => ({ ...prevState, view: triggerType }));
    }

    return () => dispatch({
      type: 'TRIGGER_SET',
      payload: {
        show: false,
        type: null,
      },
    });
  }, [dispatch, triggerShow, triggerType]);

  return (
    <MainLayout>
      {viewOpts[view]}
    </MainLayout>
  );
}
